/**
 * This SVG component used to automatically generate Icons.
 */
import * as React from "react"
import styled from "./styled"
import { omit } from "ramda"
import { slugify } from "./utils"

type DecorativeProps = {
  /**
   * Sets aria-hidden attribute on base svg when false. e.g. svg is
   * decorative part of a composition and not used standalone.
   * @default undefined
   */
  decorative: true
} & React.SVGAttributes<SVGElement>

type AccessibleProps = {
  /**
   * Aria label which should have been localized
   */
  label?: string
  /**
   * Sets aria-hidden attribute on base svg when false. e.g. svg is
   * decorative part of a composition and not used standalone.
   * @default undefined
   */
  decorative?: false
} & React.SVGAttributes<SVGElement>
type Props = Readonly<AccessibleProps | DecorativeProps>

const DecorativeSvg = (props: DecorativeProps) => (
  <svg {...omit(["size", "label", "decorative"], props)} aria-hidden="true" />
)

const AccessibleSvg = ({ label, children, ...rest }: AccessibleProps) => {
  const slugifiedID = label ? `aria_${slugify(label)}` : ""

  return (
    <svg {...omit(["size", "decorative"], rest)} aria-labelledby={slugifiedID}>
      <title id={slugifiedID}>{label}</title>
      {children}
    </svg>
  )
}

const Svg_ = (props: Props) =>
  props.decorative ? <DecorativeSvg {...props} /> : <AccessibleSvg {...props} />

const Svg = styled(Svg_)({ flex: "none !important" })

export default Svg
